/*
 * @Author: zyy
 * @Date: 2023-09-05 11:53:49
 * @LastEditTime: 2023-09-06 14:35:47
 * @FilePath: /tjzhsq-admin/src/io/vip/grade.js
 * @Description: yahu~
 * 
 */
import Axios from 'axios';
import Qs from 'qs';

export default {

    // 会员等级列表
    list(params) {
        return Axios.get('/community/api/admin/growth/level/list', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    edit(params) {
        return Axios.post(`/community/api/admin/growth/level/update/${params.id}`, params)
    },
    add(params) {
        return Axios.post(`/community/api/admin/growth/level/store`, params)
    },
    del(params) {
        return Axios.post(`/community/api/admin/growth/level/destroy/${params.id}`)
    }

}